/**
 * PermissionId
 */
enum PermissionId {
  API_KEY = 'apikey',
}
export { PermissionId };
